<template>
    <div
        class="ot-card has-no-padding order-product"
        :class="{
            disabled:
                isInvalid ||
                isResold ||
                isCancelled,
        }"
        data-testid="order-item"
    >
        <div
            class="order-product__heading"
            data-testid="order-item-heading"
        >
            <OrderItemHeading
                :is-cancelled="isCancelled"
                :is-resold="isResold"
                :is-invalid="isInvalid"
                :title="product.product.name"
            />

            <OrderItemActions
                :is-cancelled="isCancelled"
                :is-resold="isResold"
                :is-invalid="isInvalid"
                :locked="locked"
                :refund-in-progress="refundInProgress"
            />
        </div>
    </div>
</template>

<script setup lang="ts">
import type { IOrderGlobalProduct } from '@openticket/lib-order';
import { computed } from 'vue';
import OrderItemActions from './OrderItem/OrderItemActions.vue';
import OrderItemHeading from './OrderItem/OrderItemHeading.vue';

interface Props {
    product: IOrderGlobalProduct;
    locked: boolean;
}

const props = defineProps<Props>();

const refundInProgress = computed<boolean>(() => (
    !!props.product.invalidated_since
        && (props.product.invalidated_reason === 'return by visitor'
            || props.product.invalidated_reason === 'returned')
));

const isInvalid = computed<boolean>(() => (!!props.product.invalidated_reason && !refundInProgress.value));

const isResold = computed<boolean>(() => (
    !!props.product.invalidated_since
        && props.product.invalidated_reason === 'ticket is ticketswapped'
));

const isCancelled = computed<boolean>(() => (
    props.product.invalidated_reason === 'ticket-cancelled'
        || props.product.invalidated_reason === 'product-cancelled'
));

defineExpose({
    refundInProgress,
    isInvalid,
    isResold,
});
</script>

<style lang="scss" scoped>
.order-product {
    border-radius: var(--ot-card-border-radius);
    transition: var(--ot-transition-default);
    box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.1),
    0px 0px 0px 1.5px rgba(0, 0, 0, 0.05);

    &__heading {
        min-height: 5.5rem;
        padding: 0rem 1.25rem;
        box-sizing: border-box;
        display: flex;
        width: 100%;
    }

    &.disabled {
        pointer-events: none;
    }

    &.disabled & {
        &__heading {
            opacity: 0.5;
        }
    }
}
</style>
